import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StateTrackingService {
  private _previousUrl: string | null = null;
  private _currentUrl: string | null = null;

  constructor(private router: Router) {
    // Track route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this._previousUrl = this._currentUrl;
      this._currentUrl = event.urlAfterRedirects;
    });
  }

  public setPreviousState(url: string): void {
    this._previousUrl = url;
  }

  public getPreviousState(): string | null {
    return this._previousUrl;
  }

  public getCurrentUrl(): string | null {
    return this._currentUrl;
  }

  public clearPreviousState(): void {
    this._previousUrl = null;
  }
}
